// extracted by mini-css-extract-plugin
module.exports = {"label":"firmware-info_label___NZjg"};